<div class="race-chart-wrap d-flex mx-auto">
    <local-spinner #chartSpinner></local-spinner>
    <div [ngStyle]="{position: 'relative', 'height': chartHeight, 'width':chartWidth}">
            <canvas id="raceChart" [height]="chartHeight" #raceChart></canvas>
    </div>
</div>
